import { RouterProvider } from 'react-router-dom';
import {
  AuthProvider,
  SessionProvider,
  InitDataProvider,
  LanguageProvider,
  RealtimeProvider,
  ThemeProvider,
} from '@/contexts';
import { router } from '@/routes';

export function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
      <SessionProvider>
        <InitDataProvider>
          <AuthProvider>
            <RealtimeProvider>
              <RouterProvider router={router} />
            </RealtimeProvider>
          </AuthProvider>
        </InitDataProvider>
      </SessionProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
